var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialTwitch = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    fill: "none",
    viewBox: "0 0 17 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.496 9.187-2.763 2.753H9.971l-2.417 2.409v-2.41H4.446V1.616h11.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9146FF",
    d: "M3.755.239.302 3.68v12.39h4.143v3.442L7.9 16.07h2.762l6.216-6.195V.24zm11.74 8.948-2.762 2.753H9.97l-2.417 2.41v-2.41H4.445V1.615h11.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9146FF",
    d: "M13.424 4.024h-1.381v4.13h1.381z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9146FF",
    d: "M9.626 4.024H8.245v4.13h1.38z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.575,
    height: 19.273,
    fill: "#fff",
    transform: "translate(.302 .239)"
  })))));
};
export { SvgSocialTwitch as ReactComponent };